import React from "react";
import "./products.css";
import { Link } from "react-router-dom";

const ProductItemCard = ({ id, name, imageAddress }) => {
    return (
        <div className="row hrow itemsrow" >
            <Link to={`/ProductDetail/${id}`} >
                <div className="col-12 product_present" key={id}>
                    <h3 className="subject">{name}</h3>
                    <img className="img-fluid centerimg" src={`${imageAddress}`} alt="" />
                    <Link className="btn d-grid btn-outline-havayar" to={`/ProductDetail/${id}`}  >مشاهده اطلاعات دقیقتر</Link>
                </div>
            </Link>
        </div>
    );
};

export default ProductItemCard;
